import { v4 } from 'uuid';

import { RecordData } from '../../helpers-classes';
import { Rules } from '../../blueprint-classes';
import { ComponentCategoryData, ComponentCategoryDataIn } from './types';

export const componentCategoryData = (dataIn: ComponentCategoryDataIn): ComponentCategoryData => {
	const rd = new RecordData<ComponentCategoryDataIn>(dataIn);

	const record: ComponentCategoryData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		key: rd.useNewOrDefault<string>('key', ''),
		description: rd.useNewOrDefault<string>('description', ''),
		rules: rd.useNewOrDefault<Rules>('rules', { action: [], validation: [] }),
		active: rd.useNewOrDefault<boolean>('active', true),
		sort: rd.useNewOrDefault<number>('sort', 99),
		defaultPlacement: rd.useNewOrDefault<string | null>('defaultPlacement', null)
	};

	return record;
};
